import React from 'react';

export const CommentIcon = ({
  width = 16,
  height = 16,
  color = '#454550',
  fill = 'none',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M40.6639 10.6658C40.6639 8.83264 39.164 7.33276 37.3308 7.33276H10.6663C8.83313 7.33276 7.33325 8.83264 7.33325 10.6658V30.6642C7.33325 32.4974 8.83313 33.9973 10.6663 33.9973H33.9978L40.6639 40.6634V10.6658Z"
      stroke={color}
      strokeWidth="2.4998"
    />
  </svg>
);
